import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import * as vo from 'src/app/core/model/server/vo/_index';
import { AuthService } from 'src/app/core/services/auth.service';


@Injectable({
  providedIn: 'root',
})
export class rdpdService {

  constructor(
    private apiService: ApiService,
    private authService: AuthService
  ) {}


  getAllDistributors(
    page: number,
    size: number,
    request: vo.GetAllDistributorsRequest
  ): Observable<vo.GetAllDistributorsResponse> {
    return this.apiService.getAllDistributors(page, size, request);
  }

  getDistributorsChain(
    page: number,
    size: number,
    request: vo.GetDistributorsChainRequest
  ): Observable<vo.GetDistributionChainResponse> {
    return this.apiService.getDistributorsChain(page, size, request);
  }

  createRegionalDistributor(request: vo.CreateNewRDRequest): Observable<vo.BaseResponse> {
    return this.apiService.createRegionalDistributor(request);
  }

  createNewProvincialDistributor(request: vo.CreateNewPDRequest): Observable<vo.BaseResponse> {
    return this.apiService.createNewProvincialDistributor(request);
  }

  createNewRetailerDistributor(request: vo.CreateNewRetailerRequest): Observable<vo.BaseResponse> {
    return this.apiService.createNewRetailerDistributor(request);
  }

  doAction(request: vo.DistributorDoActionRequest): Observable<vo.BaseResponse> {
    return this.apiService.distributorDoAction(request);
  }

  removeDistributor(request: vo.RemoveDistributorRequest): Observable<vo.BaseResponse> {
    return this.apiService.removeDistributor(request);
  }

  exportRDPD(request: vo.ExportDistributorsRequest): void {
    try {
      this.apiService.exportDistributors(request).subscribe((blob: Blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);

        a.href = objectUrl;
        a.download = 'distributors.xlsx';
        a.click();

        URL.revokeObjectURL(objectUrl);
      });
    } catch (error) {
      throw error;
    }
  }

  get isAdmin(): boolean {
    return this.authService.isAdmin();
  }
}
